import { createSelector } from '@reduxjs/toolkit';

import { getSelectedItemIdentifiers } from '../../library/selection/selectors';
import { RootState } from '..';

export const isLivePlatingActive = createSelector(
  (state: RootState) => state.livePlating,
  getSelectedItemIdentifiers,
  (livePlating, selectedItems) =>
    selectedItems.some((item) => item.type === 'platePair' && livePlating[item.guid]?.status === 'complete'),
);

export const getPlateAnalysis = (platePairGuid: string) =>
  createSelector(
    (state: RootState) => state.livePlating[platePairGuid],
    getSelectedItemIdentifiers,
    (analysis, selectedItems) => {
      // plate is not currently selected
      if (selectedItems.every((item) => item.type !== 'platePair' || item.guid !== platePairGuid)) return null;

      // analysis is still running or never started
      if (analysis?.status !== 'complete') return null;

      return analysis.data;
    },
  );
